import type { ErrorMap } from '@/app/error-registry';

export const PROJECT_MEMBERS_ERROR_MAP: ErrorMap = {
  POST: {
    'Project.NotFound': 'projects:apiErrors.notFound',
    'Project.Forbidden': 'projects:apiErrors.forbidden',
    'Member.AlreadyExists': 'projects:apiErrors.memberAlreadyInProject',
    'Project.InvalidRole': 'projects:apiErrors.invalidRole',
    default: 'projects:apiErrors.addMemberDefault',
  },
  PUT: {
    'Project.NotFound': 'projects:apiErrors.notFound',
    'Project.Forbidden': 'projects:apiErrors.forbidden',
    'Project.InvalidRole': 'projects:apiErrors.invalidRole',
    default: 'projects:apiErrors.updateMemberDefault',
  },
  DELETE: {
    'Project.NotFound': 'projects:apiErrors.notFound',
    'Project.Forbidden': 'projects:apiErrors.forbidden',
    default: 'projects:apiErrors.removeMemberDefault',
  },
};

export const PROJECT_ICON_ERROR_MAP: ErrorMap = {
  PATCH: {
    'Project.NotFound': 'projects:apiErrors.notFound',
    'Project.Forbidden': 'projects:apiErrors.forbidden',
    default: 'projects:apiErrors.iconUploadDefault',
  },
  DELETE: {
    'Project.NotFound': 'projects:apiErrors.notFound',
    'Project.Forbidden': 'projects:apiErrors.forbidden',
    default: 'projects:apiErrors.iconDeleteDefault',
  },
};

export const PROJECTS_ERROR_MAP: ErrorMap = {
  POST: {
    'Project.NameAlreadyExists': 'projects:apiErrors.nameAlreadyExists',
    'Project.InvalidDateRange': 'projects:apiErrors.invalidDateRange',
    'Project.InvalidRole': 'projects:apiErrors.invalidRole',
    'Tag.InvalidColor': 'projects:apiErrors.tagInvalidColor',
    'ProjectField.InvalidOptions': 'projects:apiErrors.fieldInvalidOptions',
    default: 'projects:apiErrors.createDefault',
  },
  PUT: {
    'Project.NotFound': 'projects:apiErrors.notFound',
    'Project.Forbidden': 'projects:apiErrors.forbidden',
    'Project.NameAlreadyExists': 'projects:apiErrors.nameAlreadyExists',
    'Project.InvalidDateRange': 'projects:apiErrors.invalidDateRange',
    'Project.InvalidStatus': 'projects:apiErrors.invalidStatus',
    'Tag.InvalidColor': 'projects:apiErrors.tagInvalidColor',
    'ProjectField.InvalidOptions': 'projects:apiErrors.fieldInvalidOptions',
    default: 'projects:apiErrors.updateDefault',
  },
  PATCH: {
    'Project.NotFound': 'projects:apiErrors.notFound',
    'Project.Forbidden': 'projects:apiErrors.forbidden',
    'Project.AlreadyArchived': 'projects:apiErrors.alreadyArchived',
    default: 'projects:apiErrors.archiveDefault',
  },
  DELETE: {
    'Project.NotFound': 'projects:apiErrors.notFound',
    'Project.Forbidden': 'projects:apiErrors.forbidden',
    default: 'projects:apiErrors.deleteDefault',
  },
};
